export enum WeightUnit {
  LBS = 'Lbs',
  KGS = 'Kgs'
}
